import { inject, Injectable, signal } from '@angular/core';
import { GlobalWebsocketService } from '@approot/global-websocket';
import { sleep } from '@approot/utilities';
import { Subscription } from 'rxjs';
import { Detail } from './quote-schedule.component';

@Injectable()
export class QuoteScheduleService {
  private static cache = new Map<number, Detail[]>();

  private _requestId: number;

  get requestId() {
    return this._requestId;
  }

  set requestId(newVal: number) {
    this._requestId = newVal;

    const cached = QuoteScheduleService.cache.get(this.requestId);
    if (cached) {
      this.message.set(cached);
    }
  }

  public message = signal<any>({});
  private websocketService = inject(GlobalWebsocketService);
  private sub: Subscription = null;

  constructor() {
    this.startListener();
  }

  private startListener() {
    const resubscribe = () => {
      console.log('Starting QuoteScheduleService');
      this.sub?.unsubscribe();
      this.sub = this.websocketService
        .getListener({ action: 'apiv2_rfqHedgeQuote', take: Infinity })
        .subscribe({
          next: (r: any) => {
            let msg = r.payload?.message;
            if (msg.requestId === this.requestId) {
              QuoteScheduleService.cache.set(this.requestId, msg);
              this.message.set(msg);
            }
          },
          complete: async () => {
            console.log('QuoteScheduleService subscription completed');
            await sleep(500);
            setTimeout(() => resubscribe());
          },
          error: async err => {
            console.error(err);
            await sleep(500);
            setTimeout(() => resubscribe());
          }
        });
    };

    resubscribe();
  }

  public unsubscribe() {
    this.sub?.unsubscribe();
  }
}
